import { LOCAL_STORAGE_KEYS } from '@/constants'

import http from '@/$plugins/http'
import Vue from 'vue'

import base from '../base'
import IS from '../base/is'

export default {
  namespaced: true,
  state: base.createState(IS.state, {
    basket: {
      id: window.localStorage.getItem(LOCAL_STORAGE_KEYS.wishlistBasket),
      itemCount: 0,
      containedItemExternalIds: [],
      lastAction: null
    }
  }),
  getters: base.createGetters(IS.getters, {
    get: state => state.basket || {},
    getId: state => window.localStorage.getItem(LOCAL_STORAGE_KEYS.wishlistBasket),
    getItemCount: state => (state.basket && state.basket.itemCount) || 0,
    getLastAction: state => (state.basket && state.basket.lastAction) || {}
  }),
  mutations: base.createMutations(IS.mutations, {
    set (state, { basket, merge, omitLastAction }) {
      if (!basket) {
        basket = {
          id: window.localStorage.getItem(LOCAL_STORAGE_KEYS.wishlistBasket),
          itemCount: 0,
          containedItemExternalIds: [],
          lastAction: null
        }
      }
      if (omitLastAction) delete basket.lastAction

      if (merge) {
        const mergedBasket = Object.assign({}, state.basket || {}, basket)
        if (basket.containedItemExternalIds) mergedBasket.containedItemExternalIds = [...(basket.containedItemExternalIds || [])]
        Vue.set(state, 'basket', mergedBasket)
      } else {
        if (basket.containedItemExternalIds) basket.containedItemExternalIds = [...(basket.containedItemExternalIds || [])]
        Vue.set(state, 'basket', basket)
      }

      if (basket.id) {
        window.localStorage.setItem(LOCAL_STORAGE_KEYS.wishlistBasket, basket.id)
      }
    }
  }),
  actions: base.createActions(IS.actions, {
    getMinimal ({ state, getters, commit }) {
      const isKey = 'B2bWishList/getMinimal'
      commit('setLoading', { key: isKey, loading: true, initial: !state.basket || state.basket.basketState === undefined })

      return new Promise((resolve, reject) => {
        http({
          method: 'get',
          url: `/order/api/b2bwishlist/${getters.getId ? `${getters.getId}` : '00000000-0000-0000-0000-000000000000'}/small`
        })
          .then(response => {
            commit('set', { basket: response.data.result, merge: true })
            resolve(getters.get)
          })
          .catch(reject)
          .finally(() => {
            commit('setLoading', { key: isKey, loading: false })
          })
      })
    },
    get ({ state, getters, commit }) {
      const isKey = 'B2bWishList/get'
      commit('setLoading', { key: isKey, loading: true, initial: !state.basket || state.basket.basketState === undefined })

      return new Promise((resolve, reject) => {
        http({
          method: 'get',
          url: `/order/api/b2bwishlist/${getters.getId ? `${getters.getId}` : '00000000-0000-0000-0000-000000000000'}`
        })
          .then(response => {
            commit('set', { basket: response.data.result, merge: false })
            resolve(getters.get)
          })
          .catch(reject)
          .finally(() => {
            commit('setLoading', { key: isKey, loading: false })
          })
      })
    },
    delete ({ getters, commit }) {
      const isKey = 'B2bWishList/delete'
      commit('setSending', { key: isKey, sending: true })

      return new Promise((resolve, reject) => {
        http({
          method: 'delete',
          url: `/order/api/b2bwishlist/${getters.getId ? `${getters.getId}` : '00000000-0000-0000-0000-000000000000'}`
        })
          .then(response => {
            commit('set', { basket: response.data.result, merge: false })
            resolve(getters.get)
          })
          .catch(reject)
          .finally(() => {
            commit('setSending', { key: isKey, sending: false })
          })
      })
    },
    addItem ({ state, getters, commit }, { productId = '', omitLastAction = false }) {
      const isKey = 'B2bWishList/addItem'
      commit('setLoading', { key: isKey, loading: true, initial: !state.basket || state.basket.basketState === undefined })

      return new Promise((resolve, reject) => {
        http({
          method: 'put',
          url: `/order/api/b2bwishlist/${getters.getId ? `${getters.getId}` : '00000000-0000-0000-0000-000000000000'}/items/add/${productId}`,
          data: {}
        })
          .then(response => {
            commit('set', { basket: response.data.result, merge: false, omitLastAction })
            resolve(getters.get)
          })
          .catch(reject)
          .finally(() => {
            commit('setLoading', { key: isKey, loading: false })
          })
      })
    },
    removeItem ({ getters, commit }, { productId = '', omitLastAction = false }) {
      const isKey = 'B2bWishList/removeItem'
      commit('setSending', { key: isKey, sending: true })

      return new Promise((resolve, reject) => {
        http({
          method: 'delete',
          url: `/order/api/b2bwishlist/${getters.getId ? `${getters.getId}` : '00000000-0000-0000-0000-000000000000'}/items/remove/product/${productId}`
        })
          .then(response => {
            commit('set', { basket: response.data.result, merge: false, omitLastAction })
            resolve(getters.get)
          })
          .catch(reject)
          .finally(() => {
            commit('setSending', { key: isKey, sending: false })
          })
      })
    }
  })
}

